
























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TextArea extends Vue {
  @Prop() rows?: number;

  @Prop() disabled?: boolean;

  @Prop() label!: string;

  @Prop() value!: any;

  @Prop() counter?: number;

  @Prop() placeholder?: string;

  @Prop({
    required: false,
  })
  private maxLength?: number;

  beforeUpdate() {
    this.descriptionValue(this.value);
  }

  descriptionValue(value: string) {
    this.$emit('input', value);
  }
}
